'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactI18next = require('react-i18next');
var cx = require('classnames');
var Dropdown$1 = require('../alloy-dropdown/Dropdown.js');
var ListContext = require('./ListContext.js');
var styles_module = require('./styles.module.scss.js');
var constants = require('./constants.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var Dropdown = Dropdown$1.default; //TODO: remove once Dropdown component has been migrated to TS (US-150844)
var ItemsPerPage = function (_a) {
    var className = _a.className, _b = _a.items, items = _b === void 0 ? constants.DEFAULT_ITEMS_PER_PAGE_OPTIONS : _b, onChange = _a.onChange;
    var t = reactI18next.useTranslation()[0];
    var listCtx = react.useContext(ListContext.default);
    var itemsPerPage = listCtx.getItemsPerPage();
    var setItemsPerPage = listCtx.setItemsPerPage;
    var listSize = listCtx.listSize || 0;
    var itemsMinValue = Math.min.apply(Math, items);
    var handleItemsPerPageChange = function (newItemsPerPage) {
        setItemsPerPage(newItemsPerPage);
        !!onChange && onChange(newItemsPerPage);
    };
    var itemToString = function (item) { return "".concat(item); };
    var getItemsPerPage = function () { return (jsxRuntime.jsxs("div", tslib.__assign({ className: cx__default.default('d-flex', 'align-items-center', styles_module.default['items-per-page_wrapper'], className) }, { children: [jsxRuntime.jsx(Dropdown, { items: items, itemToString: itemToString, keyToString: itemToString, selected: "".concat(itemsPerPage), className: styles_module.default['items-per-page_dropdown'], onChange: handleItemsPerPageChange }), jsxRuntime.jsx("span", tslib.__assign({ className: "ms-2 my-0" }, { children: t('PC_ITEMS_PER_PAGE') }))] }))); };
    return listSize <= itemsMinValue ? null : getItemsPerPage();
};
var ItemsPerPage$1 = ItemsPerPage;

exports.default = ItemsPerPage$1;
//# sourceMappingURL=ItemsPerPage.js.map
